import React from "react";

// Slow editorial marquee — one, purposeful. Mix Playfair italic + JetBrains meta.
export default function Marquee({ items = [], tag = "" }) {
  const chunk = (
    <div className="az-marquee-track">
      {[...items, ...items, ...items].map((it, i) => (
        <span key={i} className="inline-flex items-baseline gap-6">
          <span className="font-serif italic text-[#0A0A0A] text-6xl md:text-8xl leading-none tracking-tighter">{it}</span>
          <span className="font-mono text-[10px] md:text-xs tracking-widest text-[#86868B] uppercase self-end pb-3">— {String(i + 1).padStart(3, "0")}</span>
        </span>
      ))}
    </div>
  );

  return (
    <section aria-label="Marquee" className="relative bg-[#F5F5F7] border-y border-[#E5E5EA] overflow-hidden py-14 md:py-20">
      {tag && (
        <div className="absolute top-4 left-4 md:top-6 md:left-10 az-tag" data-testid="marquee-tag">
          <span className="az-tag__dot" />
          <span>{tag}</span>
        </div>
      )}
      <div className="whitespace-nowrap">{chunk}</div>
    </section>
  );
}
